/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import PosicoesContext from '../../../../context/posicoes.context';
import './dragAndDrop.scss';

function DragAndDrop({ share: { cliente, setCliente, item } }) {
  const { setIsScreenCertifield } = useContext(PosicoesContext);
  const legenda = {
    decaAplicador: 'Declaração do Cadatro Estadual de Aplicador de Agrotóxicos*',
    decaProdutor: 'Declaração do Produtor Rural*',
    receituario: 'Receituário Agronômico*',
    notaFiscal: 'Nota Fiscal da Venda*',
  };

  useEffect(() => {
    setIsScreenCertifield(false);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: '.pdf, image/*',
    onDrop: (acceptedFiles) => {
      setCliente((prevState) => ({
        ...prevState,
        filesUpload: {
          ...prevState.filesUpload,
          [`${item}`]: acceptedFiles.map((file) => Object.assign(file, {
            preview: URL.createObjectURL(file),
          })),
        },
      }));
    },
  });
  const fileName = cliente.filesUpload[`${item}`].map((file) => {
    let fileNameEdited = file.name.replaceAll(' ', '');
    if (file.name.length > 14) {
      fileNameEdited = `${String(fileNameEdited).substring(0, 10)}...${String(fileNameEdited).substring(fileNameEdited.length - 3)}`;
    }
    return (
      <div key={file.name}>
        <span>
          {
        `${fileNameEdited}`
        }

        </span>
        {/* <img src={file.preview} style={{ width: '200px' }} alt="preview" /> */}
      </div>
    );
  });

  return (
    <div id="cards-upload">
      <div className="App drag-and-drop">
        <div className="content-drag-and-drop" {...getRootProps()}>
          <input {...getInputProps()} />
          <i className="fas fa-cloud-upload-alt" />
          <span>Arraste e solte ou clique aqui</span>
        </div>
        {fileName}
      </div>
      <span>
        {' '}
        {legenda[`${item}`]}
        {' '}
      </span>
    </div>
  );
}

DragAndDrop.propTypes = {
  share: PropTypes.shape({
    cliente: PropTypes.shape({
      filesUpload: PropTypes.node.isRequired,
      setFilesUoload: PropTypes.func.isRequired,
    }).isRequired,
    setCliente: PropTypes.func.isRequired,
    item: PropTypes.string.isRequired,
  }).isRequired,
};

export default DragAndDrop;
